
<div class="table-responsive">

  <table class="rounded table text-dark table-striped clickable">

    <thead>
      <th>{{'FAN.PAYMENT-OVERVIEW.HEADER.DATE' | translate}}</th>
      <th></th>
      <th>{{'FAN.PAYMENT-OVERVIEW.HEADER.TYPE' | translate}}</th>
      <th>{{'FAN.PAYMENT-OVERVIEW.HEADER.REFERENCE' | translate}}</th>
      <th>{{'FAN.PAYMENT-OVERVIEW.HEADER.PAYMENTMETHOD' | translate}}</th>
      <th>{{'FAN.PAYMENT-OVERVIEW.HEADER.PAYMENTTYPE' | translate}}</th>
      <th>{{'FAN.PAYMENT-OVERVIEW.HEADER.HANDLED' | translate}}</th>
      <th>{{'FAN.PAYMENT-OVERVIEW.HEADER.STATUS' | translate}}</th>
      <th>{{'FAN.PAYMENT-OVERVIEW.HEADER.DETAILS' | translate}}</th>
      <th class="text-end">{{'FAN.PAYMENT-OVERVIEW.HEADER.AMOUNT' | translate}}</th>
    </thead>

    <tbody>

      @if (pagedHistoryLines !== null && pagedHistoryLines.length == 0) {
        <tr>
          <td colspan="10">{{'FAN.PAYMENT-OVERVIEW.NOPAYMENTSFORORDER' | translate}}</td>
        </tr>
      } @else {
        @for (pl of pagedHistoryLines; track pl) {
          <tr>
            <td style="width: 100px">{{pl.ReceivedTimeStamp | localDate | replaceOnEmpty }}</td>
            <td>{{pl.ReceivedTimeStamp | localTime | replaceOnEmpty }}</td>
            <td>{{pl.Type }}</td>
            <td>{{pl.PaymentReference | replaceOnEmpty }}</td>
            <td>{{pl.PaymentMethodName }}</td>
            <td>
              @switch (pl.PaymentTypeId) {
                @case (1) {
                  <span>{{'FAN.PAYMENT-OVERVIEW.HEADER.PAYMENTTYPE.DEBETCARD' | translate}}</span>
                }
                @case (2) {
                  <span>{{'FAN.PAYMENT-OVERVIEW.HEADER.PAYMENTTYPE.CASH' | translate}}</span>
                }
                @case (3) {
                  <span>{{'FAN.PAYMENT-OVERVIEW.HEADER.PAYMENTTYPE.OTHER' | translate}}</span>
                }
                @default {
                  <span>-</span>
                }
              }
            </td>
            <td>{{pl.Handled | booleantype }}</td>
            <td>{{ getPaymentStatusText(pl.PaymentStatus) | replaceOnEmpty }}</td>
            <td style="width: 600px;">{{pl.Description | replaceOnEmpty }}</td>
            <td class="text-end">{{ pl.Amount | currency:'EUR' | replaceOnEmpty }}</td>
          </tr>
        }
      }


    </tbody>
  </table>

</div>

<!-- <div class="list-actions">
<input type="checkbox" id="showDetails"  name="showDetails" (change)="onShowDetailsChange($event)" [checked]="false" /> <label for="showDetails">&nbsp;Toon details </label>
</div> -->


<t4-pager (onPage)="doHistoryPage($event)" #historyPagerComponent></t4-pager>







